import type { FunctionComponent } from 'react';
import { MediaCountButtonV2 } from './subcomponents/MediaCountButtonV2/MediaCountButtonV2';
import { MediaCountIconsMd } from './types';

export interface MediaCount {
  iconNameMd: MediaCountIconsMd;
  title: string;
  value: string;
  imageIndexFrom?: number | null;
}

interface MediaCountButtonsProps {
  counts: MediaCount[];
  onClickHandler?: (imageIndexFrom: number) => void;
}

export const MediaCountButtonsV2: FunctionComponent<MediaCountButtonsProps> = ({
  counts,
  onClickHandler,
}) => {
  return counts.map(({ iconNameMd, title, value, imageIndexFrom }) => (
    <MediaCountButtonV2
      key={title}
      count={{ iconNameMd, title, value, imageIndexFrom }}
      onClickHandler={onClickHandler}
    />
  ));
};
